import yup from 'src/libraries/validator.library';
import {
  PilotListSchema,
  IPilotForm,
  PilotResponsePayloadSchema,
} from 'src/models/pilot.model';
import { httpClient } from 'src/libraries/http.library';

const http = httpClient();

const services = {
  listGET: async (params = { limit: 0 }) => {
    return http.get('pilots', params, PilotListSchema);
  },
  updatePUT: async (id: number, data: IPilotForm) => {
    return http.put(`pilots/${id}`, data, PilotResponsePayloadSchema);
  },
  addPOST: async (data: IPilotForm) => {
    return http.post('pilots', data, PilotResponsePayloadSchema);
  },
  itemDELETE: async (id: number) => {
    return http.delete(`pilots/${id}`, yup.mixed());
  },
};

export default services;
